import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import InputText from './InputText'

const InputTextWithMaxLength = ({
  children,
  value: _value,
  maxLength,
  onChange,
  onBlur,
  ...props
}) => {
  const [value, setValue] = React.useState(_value)

  React.useEffect(() => {
    if (!_.isEmpty(_value)) {
      setValue(_value)
    }
  }, [_value])

  function handleChange(e) {
    setValue(e.target.value)
    if (onChange) {
      onChange(e)
    }
  }

  function handleBlur(e) {
    setValue(e.target.value)
    if (onBlur) {
      onBlur(e)
    }
  }

  const currentLength = _.size(value)

  return (
    <div className="field has-addons full-width">
      <InputText
        onChange={handleChange}
        onBlur={handleBlur}
        maxLength={maxLength}
        value={value}
        {...props}
      />
      <div className="control">
        <a className="button is-static">
          {currentLength}/{maxLength}
        </a>
      </div>
    </div>
  )
}

InputTextWithMaxLength.propType = {
  maxLength: PropTypes.number.isRequired,
}

export default InputTextWithMaxLength



// WEBPACK FOOTER //
// ./src/components/views/widgets/InputTextWithMaxLength.js